module.exports = __webpack_public_path__ + "img/shared_circle.fc245ff6.png";